export const ESSAY_TYPES = [
  { name: 'Narrative', id: 1 },
  { name: 'Descriptive', id: 2 },
  { name: 'Persuasive', id: 3 },
  { name: 'Expository', id: 4 },
  { name: 'Reflective', id: 5 },
];

export const ESSAY_TYPE_MAP = {
  Narrative: 1,
  Descriptive: 2,
  Persuasive: 3,
  Expository: 4,
  Reflective: 5,
};

export const SECONDARY_ESSAY_TYPES = [
  { name: 'Personal Narrative', id: 11 },
  { name: 'Biography', id: 12 },
  { name: 'Fable', id: 13 },
  { name: 'Myth', id: 14 },
  { name: 'Sci-Fi', id: 15 },
  { name: 'Diary', id: 21 },
  { name: 'Memoir', id: 22 },
  { name: 'Poems', id: 23 },
  { name: 'Argumentative', id: 31 },
  { name: 'Editorial', id: 32 },
  { name: 'Process', id: 41 },
  { name: 'Comparative', id: 42 },
  { name: 'Definition', id: 43 },
  { name: 'Scientific', id: 44 },
  { name: 'News', id: 45 },
  { name: 'Critical', id: 51 },
];

export const WRITING_CATEGORIES = [
  { name: 'Objective', id: 1 },
  { name: 'Subjective', id: 2 },
  { name: 'Creative', id: 3 },
  { name: 'Review', id: 4 },
];

export const WRITING_CATEGORY_MAP = {
  Objective: 1,
  Subjective: 2,
  Creative: 3,
  Review: 4,
};

export const ESSAY_PROMPT_TYPES = [
  { name: 'Fixed title', id: 1 },
  { name: 'Fill-in-blank', id: 2 },
  { name: 'Choice-based', id: 3 },
  { name: 'Scenario-based', id: 4 },
  { name: 'Question', id: 5 },
  { name: 'First sentence', id: 6 },
  { name: 'Open-ended', id: 7 },
  { name: 'Perspective-Based', id: 8 },
  { name: 'Genre', id: 9 },
  { name: 'Visual', id: 10 },
  { name: 'Problem solution', id: 11 },
  { name: 'Science-focused', id: 12 },
  { name: 'Dialogue-based', id: 13 },
  { name: 'Theme-based', id: 14 },
  { name: 'Contrast', id: 15 },
  { name: 'List', id: 16 },
  { name: 'What-if', id: 17 },
  { name: 'Time-based', id: 18 },
  { name: 'Memory-based', id: 19 },
  { name: 'Emotion-based', id: 20 },
  { name: 'Retell', id: 21 },
  { name: 'Letter-based', id: 22 },
  { name: 'Map-based', id: 23 },
  { name: 'Inspirational quote', id: 24 },
  { name: 'Method…', id: 25 },
];

export const GRADE_LEVELS = [
  { name: '1st grade', id: 1 },
  { name: '2nd grade', id: 2 },
  { name: '3rd grade', id: 3 },
  { name: '4th grade', id: 4 },
  { name: '5th grade', id: 5 },
  { name: '6th grade', id: 6 },
  { name: '7th grade', id: 7 },
  { name: '8th grade', id: 8 },
  { name: '9th grade', id: 9 },
  { name: '10th grade', id: 10 },
  { name: '11th grade', id: 11 },
  { name: '12th grade', id: 12 },
  { name: 'College', id: 13 },
  { name: 'Professional', id: 14 },
];

export const GRADE_LEVEL_MAP = {
  'Pre-K': 0,
  '1st grade': 1,
  '2nd grade': 2,
  '3rd grade': 3,
  '4th grade': 4,
  '5th grade': 5,
  '6th grade': 6,
  '7th grade': 7,
  '8th grade': 8,
  '9th grade': 9,
  '10th grade': 10,
  '11th grade': 11,
  '12th grade': 12,
  College: 13,
  Professional: 14,
};

export const GENRE = [
  { name: 'Fantasy', value: 'fantasy' },
  { name: 'Legend', value: 'legend' },
  { name: 'Mystery', value: 'mystery' },
  { name: 'Horror', value: 'horror' },
  { name: 'Comedy', value: 'comedy' },
  { name: 'Adventure', value: 'adventure' },
  { name: 'Animal tale', value: 'animal tale' },
  { name: 'Fairy tale', value: 'fairy tale' },
  { name: 'Sci-Fi', value: 'sci-fi' },
  { name: 'Superhero', value: 'superhero' },
  { name: 'Historical fantasy', value: 'historical fantasy' },
];

export const GENRE_MAP = {
  Fantasy: 'fantasy',
  Legend: 'legend',
  Mystery: 'mystery',
  Horror: 'horror',
  Comedy: 'comedy',
  Adventure: 'adventure',
  'Animal tale': 'animal tale',
  'Fairy tale': 'fairy tale',
  'Sci-Fi': 'sci-fi',
  Superhero: 'superhero',
  'Historical fantasy': 'historical fantasy',
};

export const STORY_RELAY_LEVELS = [
  { name: 'Elementary', id: 1 },
  { name: 'Middle', id: 2 },
  { name: 'High', id: 3 },
  { name: 'Professional', id: 4 },
];

export const RELAY_LEVEL = [
  { Elementary: 1 },
  { Middle: 2 },
  { High: 3 },
  { Professional: 4 },
];

export const RELAY_LEVEL_MAP = {
  Elementary: 1,
  Middle: 2,
  High: 3,
  Professional: 4,
};

export const PROMPT_STATUS_MAP = {
  Draft: 1,
  Pending: 2,
  Released: 3,
  Rejected: 4,
  Rescinded: 5,
};

export const PUBLISH_STATUS_MAP = {
  Working: 1,
  Finished: 2,
  Pending: 3,
  Published: 4,
  Rejected: 5,
  Rescinded: 6,
};

export const STUDENT_PUBLISH_STATUS_MAP = {
  Unpulished: 'Finished',
  'Pending Approval': 'Pending',
  Published: 'Published',
  Rejected: 'Rejected',
  Rescinded: 'Rescinded',
};

export const USER_ACCOUNT_STATUS_MAP = {
  Active: 1,
  Inactive: 2,
  Pending: 3,
  Locked: 4,
  Terminated: 5,
};

export const SUBSCRIPTION_STATUS_MAP = {
  None: 0,
  Trialing: 1,
  Active: 2,
  'Past due': 3,
  Unpaid: 4,
  Canceled: 5,
  Incomplete: 6,
  Expired: 7,
  Ended: 8,
};

export const PLAN_TYPE_MAP = {
  free: 1,
  month: 2,
  year: 3,
};

export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const US_STATES = [
  { abbr: 'AL', name: 'Alabama' },
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'AR', name: 'Arkansas' },
  { abbr: 'CA', name: 'California' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'FL', name: 'Florida' },
  { abbr: 'GA', name: 'Georgia' },
  { abbr: 'HI', name: 'Hawaii' },
  { abbr: 'ID', name: 'Idaho' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IN', name: 'Indiana' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'LA', name: 'Louisiana' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MA', name: 'Massachusetts' },
  { abbr: 'MI', name: 'Michigan' },
  { abbr: 'MN', name: 'Minnesota' },
  { abbr: 'MS', name: 'Mississippi' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NE', name: 'Nebraska' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'NY', name: 'New York' },
  { abbr: 'NC', name: 'North Carolina' },
  { abbr: 'ND', name: 'North Dakota' },
  { abbr: 'OH', name: 'Ohio' },
  { abbr: 'OK', name: 'Oklahoma' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'PA', name: 'Pennsylvania' },
  { abbr: 'RI', name: 'Rhode Island' },
  { abbr: 'SC', name: 'South Carolina' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'TN', name: 'Tennessee' },
  { abbr: 'TX', name: 'Texas' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'VT', name: 'Vermont' },
  { abbr: 'VA', name: 'Virginia' },
  { abbr: 'WA', name: 'Washington' },
  { abbr: 'WV', name: 'West Virginia' },
  { abbr: 'WI', name: 'Wisconsin' },
  { abbr: 'WY', name: 'Wyoming' },
  { abbr: 'OTHTER', name: 'Other' },
];

export const COUNTRIES = [
  { abbr: 'AF', name: 'Afghanistan' },
  { abbr: 'AL', name: 'Albania' },
  { abbr: 'DZ', name: 'Algeria' },
  { abbr: 'AR', name: 'Argentina' },
  { abbr: 'AU', name: 'Australia' },
  { abbr: 'AT', name: 'Austria' },
  { abbr: 'BD', name: 'Bangladesh' },
  { abbr: 'BE', name: 'Belgium' },
  { abbr: 'BR', name: 'Brazil' },
  { abbr: 'CA', name: 'Canada' },
  { abbr: 'CL', name: 'Chile' },
  { abbr: 'CN', name: 'China' },
  { abbr: 'CO', name: 'Colombia' },
  { abbr: 'CU', name: 'Cuba' },
  { abbr: 'CZ', name: 'Czech Republic' },
  { abbr: 'DK', name: 'Denmark' },
  { abbr: 'EG', name: 'Egypt' },
  { abbr: 'FI', name: 'Finland' },
  { abbr: 'FR', name: 'France' },
  { abbr: 'DE', name: 'Germany' },
  { abbr: 'GR', name: 'Greece' },
  { abbr: 'HK', name: 'Hong Kong' },
  { abbr: 'HU', name: 'Hungary' },
  { abbr: 'IN', name: 'India' },
  { abbr: 'ID', name: 'Indonesia' },
  { abbr: 'IR', name: 'Iran' },
  { abbr: 'IQ', name: 'Iraq' },
  { abbr: 'IE', name: 'Ireland' },
  { abbr: 'IL', name: 'Israel' },
  { abbr: 'IT', name: 'Italy' },
  { abbr: 'JP', name: 'Japan' },
  { abbr: 'KE', name: 'Kenya' },
  { abbr: 'KR', name: 'South Korea' },
  { abbr: 'MY', name: 'Malaysia' },
  { abbr: 'MX', name: 'Mexico' },
  { abbr: 'MA', name: 'Morocco' },
  { abbr: 'NL', name: 'Netherlands' },
  { abbr: 'NZ', name: 'New Zealand' },
  { abbr: 'NG', name: 'Nigeria' },
  { abbr: 'NO', name: 'Norway' },
  { abbr: 'PK', name: 'Pakistan' },
  { abbr: 'PE', name: 'Peru' },
  { abbr: 'PH', name: 'Philippines' },
  { abbr: 'PL', name: 'Poland' },
  { abbr: 'PT', name: 'Portugal' },
  { abbr: 'QA', name: 'Qatar' },
  { abbr: 'RU', name: 'Russia' },
  { abbr: 'SA', name: 'Saudi Arabia' },
  { abbr: 'SG', name: 'Singapore' },
  { abbr: 'ZA', name: 'South Africa' },
  { abbr: 'ES', name: 'Spain' },
  { abbr: 'SE', name: 'Sweden' },
  { abbr: 'CH', name: 'Switzerland' },
  { abbr: 'TH', name: 'Thailand' },
  { abbr: 'TR', name: 'Turkey' },
  { abbr: 'AE', name: 'United Arab Emirates' },
  { abbr: 'GB', name: 'United Kingdom' },
  { abbr: 'US', name: 'United States' },
  { abbr: 'VN', name: 'Vietnam' },
  { abbr: 'OTHTER', name: 'Other' },
];

export const MOOD_EMOJI_MAP = {
  happy: "😊",
  calm: "😐",
  excited: "🤩",
  partying: "🥳",
  astonished: "😲",
  tired: "😩",
  sleepy: "😴",
  sad: "😢",
  angry: "😠",
  expressionless: "😑",
};

export const MOOD_COLOR_MAP = {
  happy: "green.200",
  calm: "teal.100",
  excited: "yellow.100",
  partying: "orange.200",
  astonished: "pink.200",
  tired: "gray.200",
  sleepy: "green.100",
  sad: "blue.100",
  angry: "red.100",
  expressionless: "gray.100",
};

export const WEATHER_EMOJI_MAP = {
  sunny: "🌞",
  "partly sunny": "⛅",
  foggy: "🌫️",
  cloudy: "☁️",
  rainy: "🌧️",
  stormy: "🌩️",
  snowy: "⛄",
  windy: "💨",
  tornado: "🌪️",
  rainbow: "🌈",
};

